<template>
  <div v-if="shouldDisplay" class="product-chart-modal">
    <GenericModal
      unique-id="productPriceChartModal"
      ref="productPriceChartModal"
      :has-header="false"
      :has-footer="false"
      :max-width="modalWidth"
      :max-height="modalHeight"
      :close-btn-color="'#ef1b1b'"
      :close-btn-position="'in'"
      :exit-modal-icon-font-size="'14px'"
      modal-open-trigger-handler-id="modal-open-product-chart-modal"
      modal-close-trigger-handler-id="modal-close-product-chart-modal"
      backgroundBlur="blur(1px)"
      border-radius="10px"
      :border="'2px solid #48bebd'"
    >
      <ProductPriceChart
        v-if="productId"
        :product-id="productId"
        :width="chartWidth"
        :height="chartHeight"
      />
    </GenericModal>

    <button class="product-chart-modal-btn" id="modal-open-product-chart-modal" @click="openModal" type="button">
      <i class="fa fa-line-chart" aria-hidden="true"></i>
      <span class="product-chart-modal-btn-text">{{ t('product.price.chart.modal.price.evolution') }}</span>
    </button>
  </div>
</template>

<script>
import GenericModal from '../presentation/GenericModal.vue'
import ProductPriceChart from './ProductPriceChart.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductPriceChartModal',
  components: {
    GenericModal,
    ProductPriceChart
  },
  data () {
    return {
      modalWidth: '650px',
      modalHeight: '435px',
      chartWidth: '100%',
      chartHeight: '375px'
    }
  },
  props: {
    productId: {
      type: Number,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ...mapGetters(
      'productChart',
      [
        'getProductChartInitialData',
        'getProductExistingChart',
        'getProductChartSettings'
      ]),
    chartInitialData () {
      return this.getProductChartInitialData(this.productId)
    },
    productChartSettings () {
      return this.getProductChartSettings
    },
    existingChart () {
      return this.getProductExistingChart(this.productId)
    },
    shouldDisplay () {
      if (this.isAdmin) {
        return true
      }

      if (!this.productChartSettings || Object.keys(this.productChartSettings).length === 0) {
        return false
      }

      if (this.productChartSettings.enabled && (this.productChartSettings.enabledGraphs || this.productChartSettings.enabledAllGraphs)) {
        return true
      }

      return false
    }
  },
  methods: {
    openModal () {
      this.$refs.productPriceChartModal.openModal()
      this.$refs.productPriceChartModal.$emit('updateChart')
    }
  }
}
</script>

<style lang="scss" scoped>
.product-chart-modal {
  position: relative;
  display: flex;
}
.product-chart-modal-btn {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 5px;
  background-color: unset;
  border: none;
  border-radius: 5px;
  color: black;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  height: 40px;
  margin: 0;
  outline: none;
  padding: 0;
  transition: all 0.3s ease-in-out;
}
::v-deep .cp-utilities-generic_modal-overlay-close {
  top: 0;
  right: 0;
  &:hover {
    transform: unset;
  }
}
</style>
